/*
 * action types
 */
export const USER_LEGEND = 'USER_LEGEND'
export const USER_MODE = 'USER_MODE'
export const USER_FONTSIZE = 'USER_FONTSIZE'

/*
 * action creators
 */
export function userLegend(payload) {
  return { payload, type: USER_LEGEND }
}
export function userMode(payload) {
  return { payload, type: USER_MODE }
}
export function userFontSize(payload) {
  return { payload, type: USER_FONTSIZE }
}
